import { styled } from '@mui/material/styles';

const DialogFixedForm = styled('form')(({ theme }) => ({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column"
}));

export {DialogFixedForm};
